import React from "react";
import cx from "classix";
import styles from "./Foto.module.scss";

// Componente Foto compartido (Fase A, bases del sistema) — toda foto del mediakit pasa por acá para
// heredar el borde claro (10.1). `className` es para posicionamiento (top/left/width/height), nunca
// para pisar el borde.
export function Foto({ src, alt = "", className, ...rest }) {
  return <img src={src} alt={alt} className={cx(styles.foto, className)} {...rest} />;
}

export default Foto;
